var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-linear',{staticClass:"bar",attrs:{"value":_vm.progress,"color":"brandGreen","height":"22"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }